import React from 'react';

const SuccessModal = ({ onClose }) => {
  // Get registration data from localStorage
  const registrationData = JSON.parse(
    localStorage.getItem('completeRegistrationData') || '{}'
  );

  const maskEmail = (email) => {
    if (!email) return '';
    const [username, domain] = email.split('@');
    if (username.length <= 3) return email;
    return username.substring(0, 3) + '...' + username.slice(-2) + '@' + domain;
  };

  const maskMobile = (mobile) => {
    if (!mobile) return '';
    if (mobile.length !== 10) return mobile;
    return mobile.substring(0, 4) + '....' + mobile.slice(-2);
  };

  return (
    <div className="modal active">
      <div className="modal-content">
        <div className="success-icon">✓</div>
        <h3>Registration Successful!</h3>
        <p>
          Registration done successfully with registration ID{' '}
          <strong>{registrationData.registrationId || 'Pending'}</strong>. 
          {registrationData.email && (
            <>
              {' '}For further details on admission process please check the email sent on{' '}
              <strong>{maskEmail(registrationData.email)}</strong>
              {registrationData.mobile && (
                <>
                  {' '}or the SMS sent on <strong>{maskMobile(registrationData.mobile)}</strong>
                </>
              )}
              .
            </>
          )}
        </p>
        {registrationData.registrationId && (
          <div className="modal-id">
            Registration ID: {registrationData.registrationId}
          </div>
        )}
        <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
          Status: <strong style={{ color: '#f39c12' }}>Pending Approval</strong>
        </p>
        <button className="btn-primary" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default SuccessModal;
